import gql from 'graphql-tag'

const getCategoryQuery = gql`
  query getCategory($categoryId: ID) {
    category(categoryId: $categoryId) {
      _id
      name
      parent {
        _id
        name
      }
      subCategories {
        items {
          _id
          name
        }
      }
      sorting {
        type
        order
      }
    }
  }
`

export default getCategoryQuery
